import { EmptyFormExt } from 'services/cfg/form'
import SUPPORTED_COUNTRIES, {
  SupportedCountryCode,
  SUPPORTED_COUNTRY_CODES,
} from './countries'
import { getGeo } from './geo'

export * from './countries'
export * from './geoareas'
export * from './multilang'
export * from './geo'

export const getCountry = () =>
  SUPPORTED_COUNTRIES.find((c) => c.geoareas.includes(getGeo()))!

const _countryCode: SupportedCountryCode = getCountry().code

/**
 * This should be used when a switch is supposed to be updated when a country is added to our platform:
 * it will force every usage of this function to be updated and the new country handling specified.
 *
 * @param expression exhaustive key-value expression covering all the supported country codes
 * @returns
 */
export const countrySwitchStrict = <TValue>(
  expression: Record<SupportedCountryCode, TValue>
) => expression[_countryCode]

/**
 * This should be used when a switch is NOT supposed to be updated when adding a country (or if we still don't know if it will)
 *
 * @param defaultValue default value will be returned if a value corresponding to the current country is not specified in the expression
 * @param expression non-exhaustive key-value expression covering only some of the supported country codes: others will be assigned with defaultValue
 * @returns
 */
export const countrySwitch = <TValue>(
  defaultValue: TValue,
  expression: Partial<Record<SupportedCountryCode, TValue>>
) => {
  const exp = SUPPORTED_COUNTRY_CODES.reduce(
    (acc, code) => ({
      ...acc,
      [code]: expression[code] || defaultValue,
    }),
    {} as Record<SupportedCountryCode, TValue>
  )
  return countrySwitchStrict(exp)
}

/**
 *
 * @param extensions Record where key is country and value is a component we want render for that country
 * @returns if our geoarea is contained in record return the component otherwise EmptyFormExt
 */
export const countrySwitchFC = (
  extensions: Partial<Record<SupportedCountryCode, React.FC>>
) => countrySwitch(EmptyFormExt, extensions)
